var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscoverDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 50,
    viewBox: "0 0 138 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.909 0H25.0909C11.2909 0 0 11.25 0 25C0 38.75 11.2909 50 25.0909 50H112.909C126.709 50 138 38.75 138 25C138 11.25 126.835 0 112.909 0ZM118.68 39.5C117.927 40.25 116.798 40.25 116.171 39.5L108.393 31.75C106.385 33 104.127 33.75 101.618 33.75C94.7182 33.75 89.0727 28.125 89.0727 21.25C89.0727 14.375 94.7182 8.75 101.618 8.75C108.518 8.75 114.164 14.375 114.164 21.25C114.164 24.375 113.035 27.25 111.027 29.375L118.555 36.875C119.307 37.75 119.307 38.875 118.68 39.5Z",
    fill: "#240630"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.619 30.25C106.607 30.25 110.651 26.2206 110.651 21.25C110.651 16.2794 106.607 12.25 101.619 12.25C96.63 12.25 92.5859 16.2794 92.5859 21.25C92.5859 26.2206 96.63 30.25 101.619 30.25Z",
    fill: "#240630"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverDark);
export default __webpack_public_path__ + "static/media/discoverDark.23f1b25e21fc03377032332b31c789bb.svg";
export { ForwardRef as ReactComponent };